module.exports = __webpack_public_path__ + "a8307dcdef043faa488a59d79e21b646.svg";